import { useState } from "react";
import { submit } from "redux-form";

import { ORGANIZATION_INFO_FORM_ID } from "@js/apps/common/constants";
import { EmployerEditWizard } from "@js/apps/employer/components/employer-edit-wizard";
import { useAppDispatch } from "@js/hooks";

import { EmployerOrganizationInfoViewLazy } from "../../lazy";

export const EmployerEditOrganizationInfoPage = () => {
  const dispatch = useAppDispatch();
  const onContinue = () => {
    dispatch(submit(ORGANIZATION_INFO_FORM_ID));
  };

  const [isAvatarUploading, setIsAvatarUploading] = useState(false);

  return (
    <EmployerEditWizard
      pageTitle="Edit Profile | Organization Info"
      continueButtonColor="secondary"
      onContinue={onContinue}
      disableSubmit={isAvatarUploading}
    >
      <EmployerOrganizationInfoViewLazy
        onIsAvatarLoading={setIsAvatarUploading}
      />
    </EmployerEditWizard>
  );
};
